import { atom } from 'recoil';
import { Alert } from '../../../types/common/modal/alert';
import { Tab } from '../../../types/estimate/common/Tab';

/**
 *  활성화된 견적탭 정보
 * @returns 1 or 2 or 3 (default: 1)
 * */
export const tabState = atom<Tab[]>({
  key: 'tab',
  default: [
    {
      id: 1,
      name: '견적 1',
      active: true,
      type: 'newcar, import, used, leaserent',
    },
    { id: 2, name: '견적 2', active: false, type: 'newcar' },
    { id: 3, name: '견적 3', active: false, type: 'newcar' },
  ],
});

/**
 *  공통 경고성 메세지 모달 정보
 * */
export const alertState = atom<Alert>({
  key: 'alert',
  default: {
    active: false,
    title: '안내',
    contents: '',
  },
});

export const loadDataInfo = atom<any>({
  key: 'loadData',
  default: null,
});
